import { HttpHeaders } from "@angular/common/http";
import {Component ,  OnInit, TemplateRef, ViewChild } from "@angular/core";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { lastValueFrom } from "rxjs";
import { ParametrosService } from "src/app/core/services/parametros.service";
import { TableAction } from "src/app/shared/components/table-paginator/table-paginator.component";
import Swal from "sweetalert2";

interface Item {
  parametro?: string;
  valorParametro?: string;
  etiqueta?: string;
  descripcion?: string;
}
@Component({
    selector: 'app-parametros',
    templateUrl: './parametros.component.html',
    styleUrls: ['./parametros.component.scss'],
})
export class ParametrosComponent implements OnInit {
    parametros:any[];
    formParametros:FormGroup;

    currentItems: Item[] = []; // Los datos para la página actual

    currentPage: number = 1;
    pageSize: number = 10; // Tamaño de página inicial
    totalItems: number = 0;
    spinner: boolean;

    customActions: TableAction[] = [];
    isEdition: boolean;

    @ViewChild('modalAgregarParametro') modalAgregarParametro!: TemplateRef<any>;
    

    
    tableHeaders = [
        { key: 'parametro', label: 'Parámetro' },
        { key: 'valorParametro', label: 'Valor Parámetro' },
        { key: 'etiqueta', label: 'Etiqueta' },
        { key: 'descripcion', label: 'Descripción' }
    ];

    

    constructor(
        private parametrosService: ParametrosService , 
        private modalService: NgbModal,
        private fb: FormBuilder
    ){
        this.formParametros = this.fb.group({
            parametro: new FormControl('' , [ Validators.required ] ),
            valorParametro: new FormControl('' , [ Validators.required ]),
            etiqueta: new FormControl( '' , [ Validators.required ] ) , 
            descripcion: new FormControl('' , [ Validators.required ])             
        });          
    }

    async ngOnInit() {           
        this.customActions = [
            {
                label: 'Editar',
                handler: (item: Item) => {

                    this.isEdition = true;
                    this.formParametros.patchValue({
                        parametro: item.parametro , 
                        valorParametro: item.valorParametro , 
                        etiqueta: item.etiqueta,
                        descripcion: item.descripcion
                    });
                    this.openModal(this.modalAgregarParametro);
                    
                },
                icon: 'fa-solid fa-pen-to-square',
                colorClass: 'bg-orange',
            },
        ];
        this.getParameters();
    }

    openModalNewParameter(){
        this.isEdition = false;
        this.formParametros.reset();
        this.openModal( this.modalAgregarParametro );
    }

    async getParameters(){
        this.spinner = true;
        const result = await lastValueFrom( this.parametrosService.getParametros(this.currentPage,this.pageSize));
    
        const headers: HttpHeaders = result.headers;
        this.spinner = false;
        this.currentItems = result.body.map((x: any, index: number) => {
            return {
            ...x
            }
        });
    
        this.totalItems = Number(headers.get('X-Total-Count'));        
    }


    action(){

        if(this.isEdition){
            this.updateParameter();
        }else {
            this.saveParameter();
        }
    }    

    async saveParameter(){    
        if( this.formParametros.valid  ){
            let response  = await lastValueFrom(this.parametrosService.addParametro({
                ...this.formParametros.value
            }));

            if( response?.message ){
                Swal.fire({
                    title: '¡Ingresado con éxito!',
                    text: response.message,
                    icon: 'success',
                    confirmButtonText: 'Ok'
                });

                this.modalService.dismissAll();
                this.getParameters();
            }                          
        }else{
            Swal.fire({
                title: '¡Campos requeridos!',
                text: 'Completa todos los campos',
                icon: 'warning',
                confirmButtonText: 'Ok'
            });
        }
    }

    async updateParameter(){
        if( this.formParametros.valid ){
            
        const { parametro , ...rest } = this.formParametros.value;

          let response =    await lastValueFrom(this.parametrosService.updateParametro( rest , parametro ));
          if( response?.message ){
            Swal.fire({
                title: 'Actualizado con éxito!',
                text: response.message,
                icon: 'success',
                confirmButtonText: 'Ok'
            });
            this.modalService.dismissAll();
            this.getParameters();
         }         
        }else{
            Swal.fire({
                title: '¡Campos requeridos!',
                text: 'Completa todos los campos',
                icon: 'warning',
                confirmButtonText: 'Ok'
            });
        }
    }



    onPageChange(newPage: number): void {
        this.currentPage = newPage;
        this.getParameters();
    }

    onPageSizeChange(newSize: number): void {
        this.pageSize = newSize;
        this.currentPage = 1;
        this.getParameters();
    }

    openModal(content: any) {        
        this.modalService.open(content, { centered: true, size: 'lg' });
    }

}